import { Button } from "antd";

import { useTranslation } from "react-i18next";
import Rules from "components/rules";

const AmountButton = ({
  disabled,
  loading,
  onChangeRules,
  handleRulesClick,
}) => {
  const { t } = useTranslation();
  return (
    <div className="p-5 fixed bottom-0 w-full max-w-2xl z-[99] ">
      <Rules
        onChangeRules={onChangeRules}
        handleRulesClick={handleRulesClick}
      />
      <Button
        disabled={disabled}
        loading={loading}
        className={`${
          disabled ? "disabled-button-large" : "primary-button-large"
        } justify-center items-center`}
        block
        htmlType="submit"
      >
        {t("continue")}
      </Button>
    </div>
  );
};
export default AmountButton;
